<!-- eslint-disable -->
<template lang="pug">
    table.schulte-table(
        :class="{\
            'schulte-table--small-border': schulteTable.length > 6,\
            'schulte-table--disabled': disabled,\
        }"
    )
        tbody
            tr.schulte-table__row(
                v-for='(row, rowIndex) in schulteTable',
                :key='rowIndex'
            )
                td.schulte-table__cell(
                    v-for='(num, numIndex) in row',
                    :key='numIndex'
                    :style="itemStyle"
                )
                    .schulte-table__press-item(@click='handleClick(num, rowIndex, numIndex)')
                        span(v-if='isColored', :style="{'color': num.color}")
                            | {{ num.number }}
                        span(v-else-if='isFlashCards')
                            abacus(
                                v-if="!!itemSize"
                                :is-from-render-table="isRenderTable"
                                :number='num.number',
                                :max-number='schulteTable.length ** 2',
                                :item-size='itemSize'
                                :digits="1"
                            )
                        span(v-else='')
                            | {{ num.number }}
</template>

<script>
    /*eslint-disable*/
    import Abacus from '../../Abacus/Abacus.vue';

    export default {
        components: {
            Abacus,
        },
        props: {
            schulteTable: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            tableId: {
                type: Number,
                default: 0
            },
            isColored: {
                type: Boolean,
                default: false,
            },
            isFlashCards: {
                type: Boolean,
                default: false,
            },
            isTenth: {
                type: Boolean,
                default: false,
            }
        },
        mounted () {
            window.addEventListener('resize', this.calculateSizeForSchulteTable);
            this.calculateSizeForSchulteTable();
        },
        data () {
           return {
               itemSize: 0,
               itemLineHeight: 73,
           }
        },
        computed: {
            itemStyle () {
                return {
                    height: this.itemSize + 'px',
                    width: this.itemSize + 'px',
                    'font-size': (this.itemLineHeight - 9) * this.fontCoefficient + 'px',
                    'line-height': this.itemLineHeight * this.fontCoefficient + 'px'
                }
            },
            fontCoefficient () {
                let coefficient = this.itemSize / this.itemLineHeight;
                if (this.isTenth || this.schulteTable.length > 3) {
                    coefficient *= this.isTenth && this.schulteTable.length > 3  ? 0.5 : 0.8;
                }
                return coefficient;
            },
            isRenderTable () {
                const schulteTablesLength = document.querySelectorAll('.schulte-table').length;
                return this.tableId === schulteTablesLength - 1
            }
        },
        methods: {
            handleClick (num, rowIndex, numIndex) {
                this.$emit('handleClick', num, rowIndex, numIndex, this.tableId);
            },
            calculateSizeForSchulteTable () {
                this.itemSize = 0;
                this.$nextTick(() => {
                    let schulteTables = Array.from(document.querySelectorAll('.schulte-table'));
                    let items = Array.from(document.querySelectorAll('.schulte-table__cell'));
                    const isSafari = /constructor/i.test(window.HTMLElement)
                        || (function (p) {return p.toString() === "[object SafariRemoteNotification]";})(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
                    const newDimensionValue = (value) => isSafari ? value * 0.88 : value;
                    let tempTableSize;
                    if (isSafari) {
                        const playBoxContainer = document.querySelector('.play-box');
                        tempTableSize = Math.min(
                            playBoxContainer.clientWidth,
                            playBoxContainer.clientHeight
                        );
                    } else {
                        tempTableSize = Math.min(
                            schulteTables[this.tableId].clientWidth,
                            schulteTables[this.tableId].clientHeight
                        );
                    }
                    if (tempTableSize < 210) {
                        tempTableSize = 210
                    }
                    schulteTables.forEach(table => {
                        table.style['height'] = newDimensionValue(tempTableSize) + 'px';
                        table.style['width'] = newDimensionValue(tempTableSize) + 'px'
                    })
                    this.itemSize = newDimensionValue(items[0].clientWidth);
                })
            }
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.calculateSizeForSchulteTable);
        }
    }
</script>

<style scoped lang="scss">
    .schulte-table {
        width: 90%;
        height: 90%;
        margin: 0 auto;

        border: 13px solid $x-color-white;
        border-collapse: collapse;
        border-spacing: 0;

        table-layout: fixed;
        box-sizing: border-box;
    }

    .schulte-table--disabled .schulte-table__press-item {
        pointer-events: none;
        cursor: auto;
        @media (hover: hover) {
            &:hover { background-color: transparent; }
        }
    }

    .schulte-table--small-border, .schulte-table--small-border .schulte-table__cell {
        border: 4px solid $x-color-white;
    }

    .schulte-table__cell {
        text-align: center;
        vertical-align: middle;
        border: 13px solid $x-color-white;
        box-sizing: border-box;
        background: $x-color-white;
        font-size: 62px;
        line-height: 73px;
    }

    .schulte-table__press-item {
        width: 80%;
        height: 80%;
        @include media($lg) {
            width: 99%;
            height: 99%;
        }
        margin: auto;
        display: flex;
        cursor: pointer;
        user-select: none;
        align-items: center;
        border-radius: $border-radius-10;
        justify-content: center;
        color: $hsl-color-green-58;
        background-color: $hsl-color-gray-97;
        transition: background-color 0.1s;
        &:hover {
            background-color: rgba($hsl-color-green-58, 0.3);
        }
    }

    .schulte-table__press-item_green {
        color: $x-color-white;
        background-color: $hsl-color-green-58;
        &:hover {
            background-color: $hsl-color-green-58;
        }
    }

    .schulte-table__press-item_white {
        transition: none;
        background-color: $hsl-color-gray-97;
        &:hover {
            background-color: $hsl-color-gray-97;
        }
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
